const SignupInitialValues = {
  id: Date.now(),
  crecheDto: {
    nom: "",
    logoId: "",
    adresseCreche: {
      rue: "",
      ville: "",
      codePostale: "",
      pays: "France"
    }
  },
  horaire: {
    ouverture: "07:30",
    fermeture: "19:00"
  },
  compteRequestDto: {
    identifiant: "",
    motDePasse: "",
    comfirmerMotDePasse: "",
    agentCrecheDto: {
      nom: "",
      prenom: "",
      email: "",
      numeroTel: 0,
      fonction: ""
    }
  }
};

export default SignupInitialValues;
